import {RENDER_TEMPLATES} from "../../../../../constants";
import workspace from "../../workspace";
import sqftConfig from "../../../store/sqftConfig";
import COLOR_THEMES from "../../../store/colorThemes";
import store from "../../../../../../../store";
import sqftShapeManager from "../../../store/sqftShapeManager";
import EventManager from "../../../store/sqftEventManager";
import PointV2, {CORE_POINT_LAYOUTS} from "../pointV2";
import {getParallelPoints, getPointField, getPointOnTheLine} from "../../../../../helpers/sqftHelper";
import {getAngleBetween3Points} from "../../../../../helpers/shapeHelper";
import {changeValuePopup} from "../../../../../../../actions/sqftMenuFunctions";
import SqftStore from "../../../store/sqftStore";
import sqftImageManager from "../../../store/sqftImageManager";
import sqftShape from "../sqftShape";
import RenderFigures from "../../../helpers/renderFigures";

export default class ShapeRotatable {
  __shape;
  __cornerPoints = [];
  rotateToPointAngle = null; // angle between shape center, hovered point and zero shape point

  constructor(shape) {
    this.__shape = shape;
    //this.__shape.setCenter(ShapeHelper.getCenterPoint(shape.getLines().map(line => line.from)));
    this.initCornerBorderPoints();
    if (shape instanceof sqftShape) {
      this.hideShapePoints();
    }
  }

  getCornerPoint() {
    return this.__shape.staticCenterPoint
  }

  getCornerPoints() {
    return this.__cornerPoints
  }

  reInitShapePoints() {
    if (this.__shape instanceof sqftShape) {
      const lines = this.__shape.getLines();
      for (const line of lines) {
        line.from.initEvents();
      }
    }
  }

  hideShapePoints() {
    const lines = this.__shape.getLines();
    for (const line of lines) {
      line.from.deregisterEvents();
    }
  }

  initCornerBorderPoints = () => {
    let minMaxPoints;
    if (this.__shape instanceof sqftShape) {
      minMaxPoints = sqftShapeManager.getMinMaxShapePoints(this.__shape, true, false)
    } else {
      minMaxPoints = sqftImageManager.getMinMaxShapePoints(this.__shape, true, false);
    }
    const {minX, maxX, minY, maxY} = minMaxPoints;
    console.log("minX, maxX, minY, maxY", minX, maxX, minY, maxY);

    let pointParams = {
      priority: EventManager.priorities.BOX_POINT,
      movable: true,
      isCentered: true,
      // isCenteredByY: pointParams.isCenteredByY,
      // isResizedByPoint: pointParams.isResizedByPoint,
      // isScaledByPoint: pointParams.isScaledByPoint,
      isVisibleOnHover: false,

      // Move point callback
      moveCallback: (mousePos, movablePoint) => {
        // get angles
        const isSlabMode = store.getState().sqftSlabState.isShowSlabTool;
        const shape = movablePoint.grandParent;
        const shapeCenter = shape.getCenter();
        const shapeCenterOnField = getPointField(shapeCenter.x, shapeCenter.y, shape);
        const movablePointOnField = getPointField(movablePoint.posX, movablePoint.posY, shape);
        const shapeZeroAnglePoint = {x: shapeCenterOnField.x, y: shapeCenterOnField.y - 50};
        let rotateToMouseAngle = getAngleBetween3Points(mousePos, shapeCenterOnField, shapeZeroAnglePoint);
        let rotatedDegrees;
        isSlabMode ? rotatedDegrees = shape.rotatedDegreesSlab : rotatedDegrees = shape.rotatedDegrees;

        if (!shape.shapeRotatable) {
          return;
        }

        // remember rotateToPointAngle angle (it is always the same)
        if (!shape.shapeRotatable.rotateToPointAngle) {
          shape.shapeRotatable.rotateToPointAngle = getAngleBetween3Points(movablePointOnField, shapeCenterOnField, shapeZeroAnglePoint);
          shape.shapeRotatable.rotateToPointAngle = mousePos.x < shapeCenterOnField.x ? 360 - shape.shapeRotatable.rotateToPointAngle : shape.shapeRotatable.rotateToPointAngle;
          //shape.shapeRotatable.rotateToPointAngle -= rotatedDegrees;
        }

        // ROTATE TO LEFT
        const rotateToAngleIn360 = mousePos.x < shapeCenterOnField.x ? 360 - rotateToMouseAngle : rotateToMouseAngle;
        const rotateToAngleWithoutHoveredPointAngle = shape.shapeRotatable.rotateToPointAngle - rotateToAngleIn360 - rotatedDegrees;
        const rotateToDegreesValue = Math.round(rotateToAngleWithoutHoveredPointAngle);

        // Normalize angle to range [0, 360)
        const normalizedRotateToDegreesValue = (rotateToDegreesValue % 360 + 360) % 360;

        if (normalizedRotateToDegreesValue) {
          this.__shape.rotate(normalizedRotateToDegreesValue, shape.Direction.LEFT, isSlabMode, this.getCornerPoint());

          // ROTATE TO RIGHT
          // const rotateToAngleWithoutHoveredPointAngle = rotateToAngle - shape.shapeRotatable.rotateToPointAngle - rotatedDegrees;
          // const rotateToDegreesValue = Math.round(rotateToAngleWithoutHoveredPointAngle);
          // this.__shape.rotate(rotateToDegreesValue, shape.Direction.RIGHT, isSlabMode, this.getCornerPoint());

          isSlabMode
            ? shape.rotatedDegreesSlab = (shape.rotatedDegreesSlab % 360 + 360) % 360
            : shape.rotatedDegrees = (shape.rotatedDegrees % 360 + 360) % 360;

          // update valuePopup
          const state = store.getState();
          const valuePopup = state.sqftMenuState.changeValuePopups.find(valuePopup => valuePopup.id === 'shape' + shape.id);
          const displayValueInPopup = isSlabMode ? shape.rotatedDegreesSlab : shape.rotatedDegrees;
          store.dispatch(changeValuePopup({
            ...valuePopup,
            value: displayValueInPopup
          }));
        }


        // Debugging information
        // console.log("rotateToDegreesValue", rotateToDegreesValue);
        // console.log("normalizedRotateToDegreesValue", normalizedRotateToDegreesValue);
        // console.log("shape.rotatedDegrees2", shape.rotatedDegrees);
        // console.log('movablePointOnField', movablePointOnField);
        // console.log("mousePos.x < shapeCenter.x", mousePos.x < shapeCenter.x);
        // console.log('rotatePointAngle', shape.shapeRotatable.rotateToPointAngle);
        // console.log('rotateToMouseAngle', rotateToMouseAngle);
        // console.log('rotateToAngle', rotateToAngle);
        // console.log("rotateToAngleWithoutHoveredPointAngle", rotateToAngleWithoutHoveredPointAngle);
        // console.log('shapeCenterOnField', shapeCenterOnField);
        // console.log('mousePos', mousePos);
        // console.log('movablePoint', movablePoint);
        // console.log('-------------------------------');
      },
      mouseUpCallback: (mousePos, movablePoint) => {
        const shape = movablePoint.grandParent;
        shape.shapeRotatable.rotateToPointAngle = null;
      }
    };
    let pointDesign = {
      radius: 5,
      lineWidth: 1,
      layout: CORE_POINT_LAYOUTS.green
    };
    this.__cornerPoints = [
      new PointV2(minX, minY, this.__shape, pointParams, pointDesign),
      new PointV2(maxX, minY, this.__shape, pointParams, pointDesign),
      new PointV2(maxX, maxY, this.__shape, pointParams, pointDesign),
      new PointV2(minX, maxY, this.__shape, pointParams, pointDesign),
    ];
  }

  destroy = () => {
    for (const cornerPoint of this.__cornerPoints) {
      cornerPoint.destroy()
    }
  }

  rotateShapeRotatablePoints = (aroundPoint, angle, isSlabMode) => {
    if (this.__shape) {
      for (const cornerPoint of this.getCornerPoints()) {
        cornerPoint.rotate(aroundPoint, angle, isSlabMode);
      }
    }
  }

  getCornerPointsPointField = () => {
    let cornerPointsPointField = [];
    for (const currentPoint of this.__cornerPoints) {
      cornerPointsPointField.push(
        getPointField( currentPoint.modelCorePoint.getPosX(), currentPoint.modelCorePoint.getPosY(), this.__shape)
      );
    }

    return cornerPointsPointField;
  }

  render = (ctx, template= RENDER_TEMPLATES.default) => {
    //this.updatePointCords();
    this.renderFrameBorder(ctx, this.__shape);
    this.renderFramePoints(ctx, this.__shape);
    if (this.__shape instanceof sqftShape) {
      this.renderLines(ctx, template);
    }
  };

  renderLines = (ctx, template= RENDER_TEMPLATES.default) => {
    if (workspace && workspace.getState().loading) return;
    const isSlabMode = SqftStore.isSlabMode();
    let lines = this.__shape.getLines();

    ctx.beginPath();
    for (let i = 0; i < lines.length; i++) {
      lines[i].render(ctx, i > 0);
    }
    if (this.__shape.isHovering() && workspace.getHoverShape() === this.__shape ) {
      ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active_hover;
    } else {
      ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active;
    }
    ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].active_disabled;
    switch (template) {
      case RENDER_TEMPLATES.linesOnly:
        ctx.lineWidth = 0;
        ctx.fill();
        ctx.closePath();
        break;
      case RENDER_TEMPLATES.default:
      default:
        ctx.fillStyle = isSlabMode ? COLOR_THEMES[sqftConfig.activeTheme].active_disabled : this.__shape.getFillColor();
        ctx.lineWidth = 2; // Math.ceil(scale);
        ctx.fill();
        ctx.closePath();
        ctx.stroke();
        break;
    }

    if (this.__shape.isHovering() && workspace.getHoveredSqftShape() === this.__shape ) {
      let sqftMenuState = store.getState().sqftMenuState;
      void sqftMenuState;
    }
  };

  renderFrameBorder = (ctx) => {
    ctx.beginPath();
    ctx.lineWidth = 2;

    let pointField = getPointField(
      this.__cornerPoints[0].modelCorePoint.getPosX(),
      this.__cornerPoints[0].modelCorePoint.getPosY(),
      this.__shape
    );
    ctx.moveTo(pointField.x, pointField.y);

    for (const cornerPoint of this.__cornerPoints) {
      pointField = getPointField(
        cornerPoint.modelCorePoint.getPosX(),
        cornerPoint.modelCorePoint.getPosY(),
        this.__shape
      );
      ctx.lineTo(pointField.x, pointField.y);
    }

    ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active;
    ctx.closePath();
    ctx.stroke();
  }

  renderFramePoints = (ctx) => {
    let len = this.__cornerPoints.length;
    const cornerPointsPointField = this.getCornerPointsPointField();
    for (const index in cornerPointsPointField) {
      //cornerPoint.render(ctx);
      if (cornerPointsPointField.hasOwnProperty(index)) {
        let current = cornerPointsPointField[+index];
        let previous = cornerPointsPointField[(+index + len - 1) % len];
        let next = cornerPointsPointField[(+index + 1) % len];

        ctx.save();
        ctx.beginPath();
        // ctx.translate(
        //   cornerPointsPointField[index].x,
        //   cornerPointsPointField[index].y,
        // );
        //ctx.rotate(90 * cornerPointIndex * (Math.PI / 180));
        // RenderFigures.drawRotatedArrow(ctx,
        //   - 20, 0,
        //   0, - 20,
        //   - 20, - 20,
        //   10
        // )
        const from = getPointOnTheLine(current, previous, 20);
        const to = getPointOnTheLine(current, next, 20);
        const [midPoint, midPoint2] = getParallelPoints(from, current,20);
        void midPoint;
        RenderFigures.drawRotatedArrow(ctx,
          from.x, from.y,
          to.x, to.y,
          midPoint2.x, midPoint2.y,
          10
        )

        //console.log("from", from);
        //console.log("to", to);
        //debugger // eslint-disable-line no-debugger
        ctx.lineWidth = 2;
        ctx.strokeStyle = 'rgba(159,197,34,0.47)';
        ctx.fillStyle = 'rgba(159,197,34,0.47)';
        ctx.stroke();
        ctx.closePath();
        ctx.restore();

        //RenderFigures.renderCircle(from, 5,1, '#63b141');
        //RenderFigures.renderCircle(to, 8,1, '#63b141');
        //RenderFigures.renderCircle({x:to.x, y: from.y}, 12,1, '#63b141');
      }
    }
  }


  // renderLinesBetweenPoints = (ctx) => {
  //   ctx.beginPath();
  //   ctx.lineWidth = lineWidth;
  //   ctx.strokeStyle = color;
  //   drawLines(ctx);
  //
  //   ctx.stroke();
  // };
}
